import React from "react";
import PropTypes from "prop-types";
import OtherSelect from "./OtherSelect";
import {getBusinessUnitOptions, getPositionTypeOptions} from "../../../services/DataGetter";

export default class OtherSearchFilter extends React.PureComponent{

    static propTypes = {
        type : PropTypes.string,
        companyOptions: PropTypes.array,
        customerName: PropTypes.string,
        changePositionTypeSelect: PropTypes.func,
        changeBusinessUnitSelect: PropTypes.func,
        changeCompanySelect: PropTypes.func,
        language: PropTypes.string,
        size: PropTypes.number,
    };

    constructor(props) {
        super(props);
        if (this.props.type === '1') {
            this.state = {onChange: this.props.changePositionTypeSelect, loading: true};
            this.loadPositionTypeOptions();
        } else if (this.props.type === '2') {
            this.state = {onChange: this.props.changeBusinessUnitSelect, loading: true};
            this.loadBusinessUnitOptions();
        }else if (this.props.type === '3') {
            this.state = {loading : false, options: this.props.companyOptions, onChange: this.props.changeCompanySelect};
        } else {
                this.state = {loading: false};
        }
    }

    loadPositionTypeOptions = async() => {
        await getPositionTypeOptions(this.props.customerName, this.props.language)
            .then(response => response.json())
            .then(json => {
                this.setState({options :json, loading : false});
            });
    };

    loadBusinessUnitOptions = async() => {
        await getBusinessUnitOptions(this.props.customerName, this.props.language)
            .then( response => response.json())
            .then(json => {
                this.setState({options: json, loading : false});
            });
    };

    render() {
        if (this.state['options'] === undefined || this.state['loading']) {
            return null;
        }
        return (
                <OtherSelect
                    language={this.props.language}
                    options={this.state['options']}
                    onChange={this.state['onChange']}
                    size={this.props.size}
                />
            );
    }
}
